// Libs
import classNames from 'classnames/bind';
import { EMPTY_VALUE } from '~/utils/constants/common';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';
import { IEventStatistic } from '~/utils/interface/statistic';
// Components, Layouts, Pages
import { TextTooltip } from '~/components/common';
// Others
// Styles, images, icons
import styles from './StatisticEvent.module.scss';

type Props = {
  title: string;
  icon: string;
  backgroundColor: string;
  events: IEventStatistic[];
  onSeeAll?: () => void;
  onClickItem?: (data: IEventStatistic) => void;
};

const cx = classNames.bind(styles);

const StatisticEvent = (props: Props) => {
  //#region Destructuring Props
  const { title, icon, backgroundColor, events, onSeeAll, onClickItem } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['admin/dashboard', 'common/base']);
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <Box component={'div'} className={cx('container')} style={{ backgroundColor: backgroundColor }}>
      <Box className={cx('header')}>
        <Box className={cx('titleGroup')}>
          <Typography className={cx('title')}>{title}</Typography>

          <img src={icon} alt={t('common_alt_img', { ns: 'common/base' })} />
        </Box>
      </Box>

      <Box className={cx('eventGroup')}>
        {events && events.length > 0 ? (
          events
            .filter((_, index) => index < 2)
            .map((item, index) => {
              return (
                <Box className={cx('event')} key={index} onClick={() => onClickItem?.(item)}>
                  <Box className={cx(index === 0 ? 'dotSent' : 'dotConverted')} />

                  <TextTooltip text={item.title || EMPTY_VALUE} className={cx('eventName')} />
                </Box>
              );
            })
        ) : (
          <Typography align='center' className={cx('noData')}>
            {t('common_no_data_available', { ns: 'common/base' })}
          </Typography>
        )}
      </Box>

      {onSeeAll && (
        <Typography component={'span'} className={cx('buttonSeeAll')} onClick={onSeeAll}>
          {t('common_button_see_all', { ns: 'common/base' })}
        </Typography>
      )}
    </Box>
  );
};

export default StatisticEvent;
